import router from '@/router'
import axios from '../../http/axios/index.js'

const apiUrl = 'https://users.evolugy.com/v1/';
const cloudFunctionUrl = 'https://us-central1-evolugy2020.cloudfunctions.net/getToken';

export default {
    fetchPermissions ({ commit }) {

      if(!axios.defaults.headers.common['Authorization']){
        const authUserKey = Object.keys(window.sessionStorage)
          .filter(item => item.startsWith('firebase:authUser'))[0];
        const authUser = JSON.parse(sessionStorage.getItem(authUserKey));
        axios.defaults.headers.common['Authorization'] = `Bearer ${authUser.stsTokenManager.accessToken}`; 
      }

      return new Promise((resolve, reject) => {
        axios.get(apiUrl+'/acl/all?perPage=50&currentPage=1',{
          headers: axios.defaults.headers.common
        })
          .then((response) => {
              console.log('permissions:');
              console.log(response);
            commit('UPDATE_PERMISSIONS', response.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
}